import PaintCommercialSummaryWorkspace from '../../placeholders/PaintCommercialSummaryWorkspace';

export default PaintCommercialSummaryWorkspace;
